export default __webpack_public_path__ + "static/media/assicura_logo.cd1b25c9.svg";